import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Shield, ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const ImpersonationBanner = () => {
  const [restoring, setRestoring] = useState(false);
  const navigate = useNavigate();

  const stored = localStorage.getItem("superadmin_return_session");
  if (!stored) return null;

  const handleReturn = async () => {
    setRestoring(true);
    try {
      const session = JSON.parse(stored);
      await supabase.auth.setSession({
        access_token: session.access_token,
        refresh_token: session.refresh_token,
      });
      localStorage.removeItem("superadmin_return_session");
      navigate("/superadmin");
    } catch {
      // If session expired, just sign out
      localStorage.removeItem("superadmin_return_session");
      await supabase.auth.signOut();
      navigate("/auth");
    } finally {
      setRestoring(false);
    }
  };

  return (
    <div className="flex items-center justify-between gap-3 bg-destructive px-4 py-1.5 text-destructive-foreground">
      <div className="flex items-center gap-2 text-xs font-medium">
        <Shield className="h-3.5 w-3.5" />
        <span>You are impersonating a user</span>
      </div>
      <Button
        variant="secondary"
        size="sm"
        className="h-6 gap-1.5 text-xs"
        onClick={handleReturn}
        disabled={restoring}
      >
        {restoring ? <Loader2 className="h-3 w-3 animate-spin" /> : <ArrowLeft className="h-3 w-3" />}
        Return to SuperAdmin
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
